import type RootStore from 'stores/RootStore'

import FieldErrorStore from './FieldErrorStore'

const initializeFieldErrors = (rootStore: RootStore) =>
  new FieldErrorStore(rootStore)

export type { default as FieldErrorStore } from './FieldErrorStore'
export default initializeFieldErrors
